export enum DiscountModuleEnum{
    Sales = 1,
    Purchase
}
export const discountSectionOptions  = [
    { label: 'Line Discount', value: 1 },
    { label: 'Footer Discount', value: 2 }
  ];